export const validationLimits = {
  maxEmailsCount: 4,
  firstNameMinimumCharacterLength: 2,
  lastNameMinimumCharacterLength: 2,
};
